/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Bondsmith Savings Exchange Operation Portal APIs
 * OpenAPI spec version: 0.1
 */
import { useQuery } from 'react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from 'react-query';
import { customInstance } from '../../../../mutator/instance';
import type {
  AccrualBalanceResponse,
  GetAvailablePreloadedAccountsParams,
  PreloadedInternalAccountResponse,
} from '../../models';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

export const getAvailablePreloadedAccounts = (
  params: GetAvailablePreloadedAccountsParams,
  signal?: AbortSignal
) => {
  return customInstance<PreloadedInternalAccountResponse[]>({
    url: `/account/preload`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGetAvailablePreloadedAccountsQueryKey = (
  params: GetAvailablePreloadedAccountsParams
) => {
  return [`/account/preload`, ...(params ? [params] : [])] as const;
};

export const getGetAvailablePreloadedAccountsQueryOptions = <
  TData = Awaited<ReturnType<typeof getAvailablePreloadedAccounts>>,
  TError = unknown
>(
  params: GetAvailablePreloadedAccountsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getAvailablePreloadedAccounts>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAvailablePreloadedAccountsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAvailablePreloadedAccounts>>
  > = ({ signal }) => getAvailablePreloadedAccounts(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAvailablePreloadedAccounts>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAvailablePreloadedAccountsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAvailablePreloadedAccounts>>
>;
export type GetAvailablePreloadedAccountsQueryError = unknown;

export const useGetAvailablePreloadedAccounts = <
  TData = Awaited<ReturnType<typeof getAvailablePreloadedAccounts>>,
  TError = unknown
>(
  params: GetAvailablePreloadedAccountsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getAvailablePreloadedAccounts>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetAvailablePreloadedAccountsQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getLatestAccruals = (
  productAccountUid: string,
  signal?: AbortSignal
) => {
  return customInstance<AccrualBalanceResponse>({
    url: `/operations/testing/interest/accruals/latest/${productAccountUid}`,
    method: 'GET',
    signal,
  });
};

export const getGetLatestAccrualsQueryKey = (productAccountUid: string) => {
  return [
    `/operations/testing/interest/accruals/latest/${productAccountUid}`,
  ] as const;
};

export const getGetLatestAccrualsQueryOptions = <
  TData = Awaited<ReturnType<typeof getLatestAccruals>>,
  TError = unknown
>(
  productAccountUid: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getLatestAccruals>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetLatestAccrualsQueryKey(productAccountUid);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getLatestAccruals>>> =
    ({ signal }) => getLatestAccruals(productAccountUid, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!productAccountUid,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getLatestAccruals>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetLatestAccrualsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getLatestAccruals>>
>;
export type GetLatestAccrualsQueryError = unknown;

export const useGetLatestAccruals = <
  TData = Awaited<ReturnType<typeof getLatestAccruals>>,
  TError = unknown
>(
  productAccountUid: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getLatestAccruals>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetLatestAccrualsQueryOptions(
    productAccountUid,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};
